import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';

function Privacy() {
  return (
    <>
      <section className="theme-light section m-0 p-0" data-theme="light">
        {/* Start flex container */}
          <div className='is-flex is-flex-direction-column is-justify-content-start'>

            {/* Navigation */}
            <div className='columns is-mobile is-flex is-flex-direction-rows is-justify-content-center'>
              <div className="m-0 p-0 column is-11"><Navigation /></div>
            </div>
            
            {/* Content */}
            <div className='pb-6 columns is-mobile is-flex is-flex-direction-rows is-justify-content-center main-content'>
              <div className="m-0 p-0 content column is-8 is-offset-4">
                <h1 className='py-4 m-0'>Privacy policy</h1>
                
                <p>Nudgemail provides this Privacy Policy to inform you of our policies and procedures regarding the collection, use, and disclosure of personal information we receive from users of <a href="https://nudgemail.com" className='textLink'>https://nudgemail.com</a> and the Nudgemail service (the "Service"). This Privacy Policy applies only to information you provide through the Site and Service. By using the Service, you consent to the collection and use of information in accordance with this Privacy Policy.</p>
                
                <p>We may update this Privacy Policy occasionally. Any material changes will be posted on <a href="https://nudgemail.com" className='textLink'>https://nudgemail.com</a>, and continued use of the Service after updates constitutes acceptance of the revised terms.</p>
                
                <h3 className='py-1 m-0'>1. Information collection</h3>
                <p>Nudgemail does not store user data beyond 90 days after the last use of the Service, except for essential account information such as contact details and preferences. Emails processed through the Service are automatically deleted 90 days after they are sent.</p>

                <p className='pb-0 mb-0'>You may provide personally identifiable information ("Personal Information") when using the Service. This includes, but is not limited to:</p>
                <ul className='pt-0 mt-2'>
                    <li>Your name, email address, phone number, and billing details (for paid accounts)</li>
                    <li>Messages or email content submitted to the Service</li>
                    <li>Any metadata associated with emails sent through Nudgemail</li>
                </ul>

                <h3 className='py-1 m-0'>2. Use of Personal Information</h3>
                <p className='pb-0 mb-0'>We use Personal Information for the following purposes:</p>
                <ul className='pt-0 mt-2'>
                    <li>To administer and improve the Service</li>
                    <li>To personalize user experience and provide customer support</li>
                    <li>To fulfill service-related requests, including sending scheduled emails</li>
                    <li>To provide account-related updates, security notifications, and feature announcements</li>
                </ul>
                <p>Nudgemail does not sell, rent, or share Personal Information with third parties for marketing or advertising purposes.</p>

                <h3 className='py-1 m-0'>3. Information sharing and disclosure</h3>
                <h4 className='py-1 m-0'>a. No Public Profiles</h4>
                <p>Nudgemail does not create or share user profiles. Your email address and stored data remain private and inaccessible to other users.</p>

                <h4 className='py-1 m-0'>b. Employee access and data handling</h4>
                <p>Nudgemail employees and contractors do not access user emails or their contents. Once an email is processed and sent, it is permanently removed from our System after 90 days. We cannot recover, resend, or access deleted emails.</p>

                <h4 className='py-1 m-0'>c. Legal compliance</h4>
                <p className='pb-0 mb-0'>We may disclose user information if required by law, regulation, subpoena, or government request. Additionally, we may disclose information when necessary to:</p>
                <ul className='pt-0 mt-2'>
                    <li>Protect the rights, property, or safety of Nudgemail, our users, or others</li>
                    <li>Prevent fraud or other illegal activities</li>
                    <li>Enforce our Terms of Service</li>
                </ul>

                <h4 className='py-1 m-0'>d. Business transfers</h4>
                <p>If Nudgemail is involved in a merger, acquisition, reorganization, or asset sale, user data may be transferred as part of the transaction. Any such transfer will be subject to the commitments outlined in this Privacy Policy.</p>

                <h3 className='py-1 m-0'>4. Data deletion and user control</h3>
                <p>Users can delete their stored emails and history through the Service interface. Permanent deletion of account-related data may be requested by contacting <a href="mailto:support@nudgemail.com" className='textLink'>support@nudgemail.com</a>.</p>

                <h3 className='py-1 m-0'>5. Security measures</h3>
                <p>We employ industry-standard security measures to protect user information from unauthorized access, disclosure, alteration, or destruction. However, no system is entirely secure, and we cannot guarantee absolute security.</p>

                <h3 className='py-1 m-0'>6. Unsolicited emails and abuse prevention</h3>
                <p>Nudgemail does not send unsolicited emails unrelated to Service functionality. </p>
                <p>If you believe someone is misusing the Service or sending unauthorized Nudgemails, please report it to <a href="mailto:support@nudgemail.com" className='textLink'>support@nudgemail.com</a>.</p>

                <h3 className='py-1 m-0'>7. Contact information</h3>
                <p>If you have any questions or concerns regarding this Privacy Policy, contact Nudgemail at <a href="mailto:support@nudgemail.com" className='textLink'>support@nudgemail.com</a> or by visiting Nudgemail's Contact us page at <a href="https://nudgemail.com/contact" className='textLink'>https://nudgemail.com/contact</a>.</p>
              </div>
            </div> 
            
            {/* Footer */}
            <div className='footer m-0 p-0 columns is-mobile is-flex is-flex-direction-rows is-justify-content-center is-align-items-center'>
              <div className="m-0 p-0 column is-11 is-10-mobile"><Footer /></div>
            </div>

          </div> 
          {/* End flex container */}
      </section>
    </>
  );
}

export default Privacy;